'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import ComponentData from './ComponentData';
import ScoreUtil from '../../util/ScoreUtil';

var OverallData = /*#__PURE__*/function (_ComponentData) {
  _inherits(OverallData, _ComponentData);

  function OverallData() {
    _classCallCheck(this, OverallData);

    return _possibleConstructorReturn(this, _getPrototypeOf(OverallData).apply(this, arguments));
  }

  _createClass(OverallData, [{
    key: "setGradeType",
    value: function setGradeType(grade) {
      this.gradeType = ScoreUtil.getOverallGradeType(grade);
    }
  }]);

  return OverallData;
}(ComponentData);

export default OverallData;